// extracted by mini-css-extract-plugin
module.exports = {"InformationPage":"InformationPage_InformationPage__lz5Uj","pageTitle":"InformationPage_pageTitle__prVX8","pageBody":"InformationPage_pageBody__3SfX5"};